import { contactIdentityKey } from '../../utils/messaging/contact-identity';
import { matchingUsers } from '../../utils/messaging/user';
import MessagingRoutesContactsHandler from './contacts-handler.js';

export default class MessagingRoutesAddMembersContactsHandler extends MessagingRoutesContactsHandler {
  titleKey = 'emc.add_team_members.title';
  ctaKey = 'emc.add_team_members.add_button';
  showListSections = false;
  multiSelect = true;
  showScopeIndicator = true;
  showEmptyStateBanner = false;
  showNoSearchResultsBanner = true;

  get conversation() {
    return this.options.conversation ?? this.options.parentHandler?.conversation;
  }

  augmentFilter(filter) {
    return { ...filter, external_scope: 'User' };
  }

  getLockedContacts(currentUser) {
    const members = this.conversation?.collapsedMembers ?? [];
    return members
      .filter(member => member.isCouple || !(currentUser && matchingUsers(member, currentUser)))
      .map(member => this.#lockedContact(member));
  }

  #lockedContact(member) {
    return {
      id: String(member.externalId),
      externalId: String(member.externalId),
      externalScope: member.externalScope,
      name: member.name,
      isClient: member.isClient,
    };
  }

  get submitCount() {
    let count = 0;
    for (const contact of this.selectedContacts) {
      if (!this.lockedContactIds.has(contactIdentityKey(contact))) count++;
    }
    return count;
  }

  submit(selectedContacts) {
    const newMembers = selectedContacts.filter(
      contact => !this.lockedContactIds.has(contactIdentityKey(contact))
    );
    return this.messagingNavigation.toAddMembersHistory(newMembers);
  }

  leave() {
    return this.messagingNavigation.leaveChildRoute();
  }
}
